<div
  class="xi-modal__container field-create__container"
  *transloco="let t; read: 'field-create-dialog'"
>
  <div class="xi-modal__title field-create__header-wrapper">
    <h2 class="field-create__title">{{ t('create-metadata-field') }}</h2>
    <a
      class="no-style right-align field-create__info-link"
      [href]="'https://spotlight-docs.lexalytics.com/docs/metadata-field-management'"
      target="_blank"
    >
      <xi-icon-button icon="info" color="CX" [hasAnimation]="false" [fill]="'no-fill'">
      </xi-icon-button>
    </a>
  </div>
  <form [formGroup]="fieldCreateForm" (ngSubmit)="onCreateField()">
    <div class="xi-modal__content field-create__content">
      <div class="field-create__input-wrapper">
        <label class="field-create__text-input-label" for="field-create__name">{{
          t('name')
        }}</label>
        <xi-input-field
          formControlName="name"
          [status]="fieldNameStatus"
          placeholder="{{ t('enter-name-metadata-field') }}"
          icon="cancel"
          inputId="field-create__name"
          (onIconClick)="fieldCreateForm.patchValue({ name: '' })"
        ></xi-input-field>
      </div>

      <div class="field-create__input-wrapper">
        <label for="field-create__type">{{ t('type') }}</label>
        <xi-dropdown
          formControlName="type"
          inputId="field-create__type"
          [data]="fieldTypes"
          [stretch]="true"
          placeholder="{{ t('select-type-metadata-field') }}"
        ></xi-dropdown>
      </div>

      @if (aliasSelected) {
        <div class="field-create__input-wrapper">
          <label for="field-create__subtype">{{ t('subtype') }}</label>
          <xi-dropdown
            formControlName="subtype"
            inputId="field-create__subtype"
            [data]="fieldSubTypes"
            [stretch]="true"
          ></xi-dropdown>
        </div>
        <label>{{ t('fields') }}</label>
        <app-field-alias-selector
          [fields]="fields"
          [subType]="selectedSubType"
          [selectedAliasedFields]="[preSelectedField?.fieldName]"
          [newAlias]="true"
          (selectionChanged)="onAliasSelectionChange($event)"
        ></app-field-alias-selector>
      }
      @if (isCalculatedField) {
        <div class="field-create__input-wrapper">
          <label for="field-create__calcType">{{ t('calculation-type') }}</label>
          <xi-dropdown
            formControlName="calcType"
            inputId="field-create__calcType"
            [data]="calcTypes"
            [stretch]="true"
            placeholder="{{ t('select-calculation-type') }}"
          ></xi-dropdown>
        </div>
        <div class="field-create__input-wrapper">
          <label for="field-create__calcDef">{{ t('calculation-definition') }}</label>
          <xi-text-area
            formControlName="calcDef"
            inputId="field-create__calcDef"
            placeholder="{{ t('calculation-definition-placeholder') }}"
            type="text"
            [status]="calcDefStatus"
            class="field-create__calc-def"
          >
          </xi-text-area>
        </div>
      }
      @if (type.valid) {
        <div class="field-create__input-wrapper">
          <label for="field-create__filterable">{{ t('is-filterable') }}</label>
          <xi-toggle-switch
            formControlName="isFilterable"
            inputId="field-create__filterable"
          ></xi-toggle-switch>
        </div>
        @if (!isCalculatedField) {
          <div class="field-create__input-wrapper">
            <label for="field-create__contains-pii">{{ t('contains-pii') }}</label>
            <div [matTooltip]="containsPIITooltip">
              <xi-toggle-switch
                formControlName="containsPII"
                inputId="field-create__contains-pii"
              ></xi-toggle-switch>
            </div>
          </div>
        }
      }
    </div>

    <div class="xi-modal__actions field-create__actions">
      <xi-default-button
        type="button"
        text="{{ t('cancel') }}"
        fill="text"
        (onClick)="onCancel()"
      ></xi-default-button>

      <xi-default-button
        [disabled]="!fieldCreateForm.valid || (aliasSelected && !includedFieldsValid)"
        text="{{ t('add-metadata-field') }}"
      ></xi-default-button>
    </div>
  </form>
</div>
